import year2016 from './2016'
import year2017 from './2017'
import year2018 from './2018'
import year2019 from './2019'

module.exports = {
  year2016,
  year2017,
  year2018,
  year2019
}



// WEBPACK FOOTER //
// ./data/index.js